import { ReactElement } from 'react';

import AuthorLayout from 'components/AuthorLayout';

function Dashboard(): ReactElement<HTMLElement> {
  return (
    <AuthorLayout title="Dashboard">
      <p className="font-body">Welcome.</p>
    </AuthorLayout>
  );
}

export default Dashboard;
